import React from "react";
/** Accounting supplies net action charges; returns are explanatory, not another subtraction. */
function exactCredits(value: unknown): string {
  return Math.max(0, Number(value) || 0).toLocaleString(undefined, { maximumFractionDigits: 4 });
}
export function formatUsageBreakdown(item: { label: string; credits: number; creditsRefunded?: number }): string {
  const returned = Number(item.creditsRefunded) || 0;
  return `${item.label} ${returned > 0 ? exactCredits(item.credits) : Number(item.credits).toFixed(0)}${returned > 0 ? ` (${exactCredits(returned)} returned)` : ''}`;
}
export function UsageCreditAmount({ creditsActual, creditsRefunded = 0, originalCreditsActual }: { creditsActual: number; creditsRefunded?: number; originalCreditsActual?: number }) {
  const net = Math.max(0, Number(creditsActual) || 0);
  const returned = Math.max(0, Number(creditsRefunded) || 0);
  return (
    <div className="text-right font-mono tabular-nums text-neutral-700" title={returned > 0 ? `Originally ${exactCredits(originalCreditsActual ?? net + returned)} credits; net charge ${exactCredits(net)} credits` : undefined}>
      <div>{net > 0 ? '−' : ''}{returned > 0 ? exactCredits(net) : net.toFixed(0)}</div>
      {returned > 0 && <div className="mt-0.5 text-[11px] text-emerald-700" data-testid="usage-credits-returned">{exactCredits(returned)} credits returned</div>}
    </div>
  );
}
